import React from "react";
import Card from "@/components/Card";
import { useSelector } from "react-redux";
import { DashSel } from "@/features/dashboard";
import { Col, Row } from "antd";
import { TitleCase } from "@/utils/string";
import { round } from "lodash";
import { CrownTwoTone, DislikeTwoTone } from "@ant-design/icons/lib";

import Breakdown from "./Breakdown";
import { useBenchmarkContext } from "../hook";

export default ({ investmentStyle }: { investmentStyle: string }) => {
  const { isAll, selectedKey, exchange, group } = useBenchmarkContext();
  const benchmarkData = useSelector(DashSel.benchmarkData(exchange));
  const totalScore = benchmarkData.totalScore.filter(
    data => data.investmentStyle === investmentStyle && (isAll || group.includes(data.group))
  );

  return (
    <Row gutter={[12, 12]}>
      {totalScore.map(data => (
        <Col span={6 * selectedKey.length} key={data.group} className={data.group}>
          <Card
            title={TitleCase(data.group)}
            extra={<Breakdown totalScore={data} breakdown={getBreakdownData(data.group)} />}
          >
            {data.score
              .slice()
              .sort((a, b) => b.score - a.score)
              .map((s, i) => (
                <Row justify={"space-around"} key={s.ticker + i}>
                  <Col span={6}>
                    {s.ticker} {getRankIcon(i, data.score.length)}
                  </Col>
                  <Col span={6}>{round(s.score, 2)}</Col>
                </Row>
              ))}
          </Card>
        </Col>
      ))}
    </Row>
  );

  function getBreakdownData(group: string) {
    return benchmarkData.breakdown.find(d => d.investmentStyle === investmentStyle && d.group === group);
  }

  function getRankIcon(i: number, totalNumber: number) {
    if (i === 0) {
      return <CrownTwoTone twoToneColor={"#E6E600"} style={{ fontSize: "20px" }} />;
    } else if (i === totalNumber - 1) {
      return <DislikeTwoTone twoToneColor="#eb2f96" style={{ fontSize: "14px" }} />;
    }
    return null;
  }
};
